<template>
  <div
    class="pc-homework-custom-page"
    :class="{
      'electron-homework-custom-page': isElectron,
    }"
  >
    <div>
      <!-- 作业详情 -->
      <homework-detail :workInfo="workInfo" :questionInfo="questionInfo" />
      <!-- 我的作业 -->
      <my-work-info
        :workInfo="workInfo"
        :questionInfo="questionInfo"
        @updateWorkInfo="handleUpdateWorkInfo"
        @updateOnlyTeacherLook="handleUpdateOnlyTeacherLook"
      />
      <!-- 同学作业 -->
      <classmate-homework />
    </div>
  </div>
</template>

<script>
import {
  getWorkInfo,
  getQuestionList,
  getQuestionInfo,
} from "@saas/service-api/src/homework/index";
import HomeworkDetail from "@saas/pages/src/homework-custom/components/HomeworkDetail.vue";
import MyWorkInfo from "@saas/pages/src/homework-custom/components/MyWorkInfo.vue";
import ClassmateHomework from "@saas/pages/src/homework-custom/components/ClassmateHomework.vue";
export default {
  components: {
    HomeworkDetail,
    MyWorkInfo,
    ClassmateHomework,
  },
  data: function () {
    return {
      work_id: null,
      workInfo: {},
      questionList: [],
      questionInfo: {},
      isElectron: window.isElectron,
    };
  },
  mounted() {
    this.work_id = this.$route.params.id;
    this.questionList = [];
    this.apiGetWorkInfo();
  },
  methods: {
    handleUpdateOnlyTeacherLook(val) {
      this.workInfo.stu_only_teacher_look = val;
    },
    handleUpdateWorkInfo() {
      this.apiGetWorkInfo();
    },
    apiGetWorkInfo() {
      getWorkInfo({
        work_id: this.work_id,
      })
        .then((res) => {
          if (res.code === 1) {
            // 判断是否超时
            this.workInfo = this.judgeTimeOut(res.data || {});
            if (this.questionList?.length) {
              this.apiGetQuestionInfo();
            } else {
              this.apiGetQuestionList();
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
    judgeTimeOut(workInfo) {
      let now = new Date().getTime();
      if (workInfo?.work_end_time && workInfo.work_end_time * 1000 < now) {
        workInfo.isTimeOut = true;
      } else {
        workInfo.isTimeOut = false;
      }
      return workInfo;
    },
    apiGetQuestionInfo() {
      let question_ids = this.questionList.map((item) => {
        return item.question_id;
      });
      question_ids = question_ids.join(",");
      getQuestionInfo({
        work_id: this.work_id,
        question_ids,
      })
        .then((res) => {
          if (res.code === 1) {
            this.questionInfo = res.data?.[0] || {};
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
    apiGetQuestionList() {
      getQuestionList({
        work_id: this.work_id,
      })
        .then((res) => {
          if (res.code === 1) {
            this.questionList = res.data || [];
            this.apiGetQuestionInfo();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-homework-custom-page {
  width: 1210px;
  min-height: calc(100vh - #{$nav-bar-height});
  padding: 20px 0;
  margin: 0 auto;
  & > div {
    padding: 10px 10px 20px;
    background: #ffffff;
    border-radius: 16px;
  }
}
// electron
.pc-homework-custom-page.electron-homework-custom-page {
  padding: 0 0 20px;
}

// 适配
@media (max-width: 1210px) {
  .pc-homework-custom-page {
    width: 100%;
  }
}
</style>
